/* Plot.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _7 = "._1pbyidpf{z-index:0}";
const _6 = "._18m9ewfl{overflow-y:visible}";
const _5 = "._1reoewfl{overflow-x:visible}";
const _4 = "._1tkeidpf{min-height:0}";
const _3 = "._1ul9idpf{min-width:0}";
const _2 = "._16jlkb7n{flex-grow:1}";
const _ = "._nd5lah6b{grid-area:plot}";
export default function Plot(_ref) {
  let {
    top = 0,
    left = 0,
    width = '100%',
    height = '100%',
    transform,
    children,
    innerRef,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7]
      }), /*#__PURE__*/_jsx("svg", {
        ref: innerRef,
        width: width,
        height: height,
        transform: transform || `translate(${left}, ${top})`,
        ...restProps,
        className: ax(["_nd5lah6b _16jlkb7n _1ul9idpf _1tkeidpf _1reoewfl _18m9ewfl _1pbyidpf"]),
        children: children
      })]
    })
  });
}